import api from './client'
import { invalidateVocabularyStats } from '@/hooks/useVocabularyStats'
import type { CustomFlashcard, CustomFlashcardInput } from '@/types/customFlashcard'

export function fetchCustomFlashcards(languageId: number) {
  return api.get<{ data: CustomFlashcard[] }>('/custom_flashcards', {
    params: { language_id: languageId },
  })
}

export function createCustomFlashcard(input: CustomFlashcardInput) {
  return api
    .post<{ data: CustomFlashcard }>('/custom_flashcards', { custom_flashcard: input })
    .then((res) => {
      invalidateVocabularyStats(input.language_id)
      return res
    })
}

export function updateCustomFlashcard(
  id: number,
  languageId: number,
  input: Omit<CustomFlashcardInput, 'language_id'>,
) {
  return api
    .patch<{ data: CustomFlashcard }>(`/custom_flashcards/${id}`, { custom_flashcard: input })
    .then((res) => {
      invalidateVocabularyStats(languageId)
      return res
    })
}

export function deleteCustomFlashcard(id: number, languageId: number) {
  return api.delete<void>(`/custom_flashcards/${id}`).then((res) => {
    invalidateVocabularyStats(languageId)
    return res
  })
}
